export type GlobeRenderProfileInput = {
  viewportWidth: number;
  coarsePointer: boolean;
  deviceMemoryGb?: number;
};

export type GlobeRenderProfile = {
  reduced: boolean;
  antialias: boolean;
  stencil: boolean;
  hardwareScalingLevel: number;
  loadObjGlobeModel: boolean;
  earthSegments: number;
  atmosphereSegments: number;
  markerSegments: number;
  glowBlurKernelSize: number;
  glowTextureSize?: number;
};

export function getGlobeRenderProfile(input: GlobeRenderProfileInput): GlobeRenderProfile {
  const constrainedMemory = input.deviceMemoryGb !== undefined && input.deviceMemoryGb <= 4;
  const reduced = input.viewportWidth < 768 || input.coarsePointer || constrainedMemory;

  return reduced
    ? {
        reduced: true,
        antialias: false,
        stencil: false,
        hardwareScalingLevel: 1.25,
        loadObjGlobeModel: false,
        earthSegments: 64,
        atmosphereSegments: 48,
        markerSegments: 10,
        glowBlurKernelSize: 24,
        glowTextureSize: 256,
      }
    : {
        reduced: false,
        antialias: true,
        stencil: true,
        hardwareScalingLevel: 1,
        loadObjGlobeModel: true,
        earthSegments: 128,
        atmosphereSegments: 96,
        markerSegments: 18,
        glowBlurKernelSize: 48,
      };
}
